import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import { validators } from "investira.sdk";
import {
  Stack,
  Button,
  Menu,
  MenuItem,
  Switch,
  FormControlLabel,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "investira.react.components";

const METRICAS_TIPO = {
  CS: { id: "cs", descricao: "Capital Social" },
  PL: { id: "pl", descricao: "Patrimônio Líquido" },
  MARKET_VALUE: { id: "market_value", descricao: "Valor de Mercado" },
};

const FilterMetricas = memo((props) => {
  const { values, onChange } = props;
  const [anchorElMetrica, setAnchorElMetrica] = useState(null);

  const openMetrica = Boolean(anchorElMetrica);

  const handleChange = (pAttribute, pValue) => {
    if (pValue !== null) {
      onChange({ ...values, [pAttribute]: pValue });
    }
  };

  function handleClickMetrica(pEvent) {
    setAnchorElMetrica(pEvent.currentTarget);
  }

  function handleCloseMetrica() {
    setAnchorElMetrica(null);
  }

  function handleSetMetrica(pValue) {
    handleChange("metrica", pValue);
    handleCloseMetrica();
  }

  function renderMetricaMenu(pMetricasTipo, pCurrentMetrica) {
    if (validators.isEmpty(pMetricasTipo)) {
      return null;
    }

    const xOptions = Object.values(pMetricasTipo);

    const xMenu = xOptions.map((xItem) => {
      return {
        label: xItem.descricao,
        value: xItem.id,
      };
    });

    const xCurrentLabel = xOptions.find(
      (xItem) => xItem.id === pCurrentMetrica,
    );

    const xProps = {
      ...(xOptions.length >= 2
        ? { onClick: handleClickMetrica }
        : { disabled: true }),
    };

    return (
      <>
        <Button
          variant="outlined"
          size="small"
          disableElevation
          {...xProps}
          sx={{ fontSize: "0.7rem", padding: "3px 8px" }}
        >
          {xCurrentLabel?.descricao}
        </Button>
        <Menu
          anchorEl={anchorElMetrica}
          open={openMetrica}
          onClose={handleCloseMetrica}
        >
          {xMenu.map((xItem) => {
            return (
              <MenuItem
                key={xItem.value}
                onClick={() => handleSetMetrica(xItem.value)}
              >
                {xItem.label}
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  }

  function renderFaixaToggle(pCurrentFaixa) {
    return (
      <ToggleButtonGroup
        value={pCurrentFaixa}
        exclusive
        onChange={(e, pNewValue) => handleChange("faixa", pNewValue)}
        size="small"
        color="primary"
        aria-label="Faixa de valores"
      >
        <ToggleButton
          value="menores"
          sx={{ fontSize: "0.7rem", padding: "3px 8px" }}
        >
          Menores
        </ToggleButton>
        <ToggleButton
          value="proximos"
          sx={{ fontSize: "0.7rem", padding: "3px 8px" }}
        >
          Ambos
        </ToggleButton>
        <ToggleButton
          value="maiores"
          sx={{ fontSize: "0.7rem", padding: "3px 8px" }}
        >
          Maiores
        </ToggleButton>
      </ToggleButtonGroup>
    );
  }

  return (
    <Stack spacing={1}>
      <Stack
        spacing={2}
        direction="row"
        flexWrap="wrap"
        useFlexGap
        alignItems="center"
      >
        {renderMetricaMenu(METRICAS_TIPO, values?.metrica)}
        {renderFaixaToggle(values?.faixa)}
      </Stack>
      <FormControlLabel
        control={
          <Switch
            checked={values?.similaridade === "setor"}
            onChange={(e) =>
              handleChange(
                "similaridade",
                e.target.checked ? "setor" : "metrica",
              )
            }
            size="small"
          />
        }
        label={
          <Typography variant="body2" color="textPrimary">
            Mesmo setor
          </Typography>
        }
      />
    </Stack>
  );
});

FilterMetricas.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func,
};

export default FilterMetricas;
